if (document.querySelector('cart-drawer.is-empty')) {
  try { sessionStorage.removeItem('lv-sculpt-cart-deadline-v1'); } catch {}
}

if (!customElements.get('lv-cart-timer')) {
  customElements.define('lv-cart-timer', class extends HTMLElement {
    connectedCallback() {
      const key = 'lv-sculpt-cart-deadline-v1';
      const duration = 10 * 60 * 1000;
      let deadline;
      try {
        deadline = Number(sessionStorage.getItem(key));
        if (!Number.isFinite(deadline) || deadline <= 0 || deadline > Date.now() + duration) {
          deadline = Date.now() + duration;
          sessionStorage.setItem(key, String(deadline));
        }
      } catch {
        deadline = Date.now() + duration;
      }
      const tick = () => {
        const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        const clock = this.querySelector('[data-cart-clock]');
        if (clock) clock.textContent = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
      };
      tick();
      this.interval = setInterval(tick, 1000);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      queueMicrotask(() => {
        if (document.querySelector('cart-drawer.is-empty')) {
          try { sessionStorage.removeItem('lv-sculpt-cart-deadline-v1'); } catch {}
        }
      });
    }
  });
}

if (!customElements.get('lv-cart-options')) {
  customElements.define('lv-cart-options', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (event) => {
        if (!event.target.matches('[data-cart-option]')) return;
        event.stopPropagation();
        this.changeVariant();
      });
    }
    async changeVariant() {
      if (this.busy) return;
      const selectors = [...this.querySelectorAll('[data-cart-option]')];
      const values = selectors.map(select => select.value);
      const variants = JSON.parse(this.querySelector('[data-cart-variants]').textContent);
      const variant = variants.find(candidate => candidate.options.every((value, index) => value === values[index]));
      const error = document.getElementById('CartDrawer-CartErrors');
      const reset = () => {
        selectors.forEach(select => select.value = select.querySelector('[selected]')?.value || select.options[0].value);
      };
      if (!variant?.available) {
        reset();
        if (error) error.textContent = this.dataset.error;
        return;
      }
      this.busy = true;
      const drawer = this.closest('cart-drawer');
      const controls = [...drawer.querySelectorAll('button,select,input')];
      const enabled = controls.filter(control => !control.disabled);
      enabled.forEach(control => control.disabled = true);
      drawer.setAttribute('aria-busy', 'true');
      if (error) error.textContent = '';
      let addedKey;
      let originalAddedQuantity = 0;
      let removed = false;
      const root = window.Shopify?.routes?.root || '/';
      const post = (path, body) => new Promise((resolve, reject) => {
        const request = new XMLHttpRequest();
        request.open('POST', `${root}cart/${path}.js`);
        request.setRequestHeader('Content-Type', 'application/json');
        request.setRequestHeader('Accept', 'application/json');
        request.onload = () => {
          try {
            const result = JSON.parse(request.responseText);
            if (request.status < 200 || request.status >= 300 || result.errors) throw new Error(result.description || this.dataset.error);
            resolve(result);
          } catch (error) { reject(error); }
        };
        request.onerror = () => reject(new Error(this.dataset.error));
        request.send(JSON.stringify(body));
      });
      try {
        const before = await fetch(`${root}cart.js`).then(response => {if (!response.ok) throw new Error(); return response.json();});
        const line = before.items.find(item => item.key === this.dataset.key);
        if (!line) throw new Error();
        const sameGroup = candidate => candidate.variant_id === line.variant_id && JSON.stringify(candidate.properties || {}) === JSON.stringify(line.properties || {});
        const sourceLines = before.items.filter(sameGroup);
        const quantity = sourceLines.reduce((sum, item) => sum + item.quantity, 0);
        const item = {id:variant.id,quantity,properties:line.properties || {}};
        if (line.selling_plan_allocation) item.selling_plan = line.selling_plan_allocation.selling_plan.id;
        const bundleData = candidate => {
          try { return JSON.parse(candidate.properties?.__kaching_bundles || '{}'); } catch { return {}; }
        };
        const bundle = bundleData(line);
        const companions = bundle.v ? before.items.filter(candidate => {
          const data = bundleData(candidate);
          return data.id === bundle.id && data.deal === bundle.deal && !sameGroup(candidate);
        }) : [];
        const grouped = new Map();
        for (const companion of companions) {
          const key = `${companion.variant_id}:${JSON.stringify(companion.properties || {})}`;
          const entry = grouped.get(key) || {id:companion.variant_id,quantity:0,properties:companion.properties || {}};
          entry.quantity += companion.quantity;
          if (companion.selling_plan_allocation) entry.selling_plan = companion.selling_plan_allocation.selling_plan.id;
          grouped.set(key, entry);
        }
        const added = await post('add', {items:[item,...grouped.values()]});
        addedKey = added.items[0].key;
        originalAddedQuantity = before.items.find(item => item.key === addedKey)?.quantity || 0;
        const after = await fetch(`${root}cart.js`).then(response => response.json());
        const updates = {};
        for (const source of after.items.filter(sameGroup)) updates[source.key] = 0;
        for (const companion of grouped.values()) {
          const matches = after.items.filter(candidate => candidate.variant_id === companion.id && JSON.stringify(candidate.properties || {}) === JSON.stringify(companion.properties));
          matches.forEach((candidate, index) => updates[candidate.key] = index === 0 ? companion.quantity : 0);
        }
        const result = await post('update', {updates,sections:drawer.getSectionsToRender().map(section => section.id),sections_url:location.pathname});
        removed = true;
        if (Object.values(result.sections || {}).some(section => !section) || !result.sections) {
          location.reload();
          return;
        }
        drawer.renderContents(result);
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {source:'cart-items',cartData:result});
      } catch {
        if (addedKey && !removed) {
          try { await post('change', {id:addedKey,quantity:originalAddedQuantity}); }
          catch { location.reload(); return; }
        }
        reset();
        if (error) error.textContent = this.dataset.error;
      } finally {
        enabled.forEach(control => control.disabled = false);
        drawer.removeAttribute('aria-busy');
        this.busy = false;
      }
    }
  });
}
